<template>
    <div class="d-flex justify-space-between pa-2 navigation-step-buttons">

        <SportipsButton v-if="canGoBack" @click="goToPreviousStep" action-button chevronLeft text>Retour
        </SportipsButton>
        <v-spacer v-else></v-spacer>
        <SportipsButton v-show="canContinue" @click="goToNextStep" action-button chevron :loading="loading">{{
            continueLabel || (isLastStep ? 'Continuer' : 'Continuer') }}
        </SportipsButton>
    </div>
</template>

<script>
export default {
    props: {
        canContinue: {
            type: Boolean,
            required: true
        },
        canGoBack: {
            type: Boolean,
            required: true
        },
        isLastStep: {
            type: Boolean,
            default: false
        },
        continueLabel: {
            type: String,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        goToNextStep() {
            this.$emit('goToNextStep');
        },
        goToPreviousStep() {
            this.$emit('goToPreviousStep');
        }
    }
}
</script>

<style lang="scss">
.navigation-step-buttons {
    border-top: 1px solid rgb(221, 221, 221) !important;
}
</style>